import styled from "styled-components";

export const wideModalWidth = "90%";

export const FixedWidthContent = styled.div`
  max-width: 1600px;
  margin: auto;
`;
